export const getVrmErrorTexts = () => ({ detail: 'Something went wrong', title: 'Error' });

export const CAR_CHECK_SNOWPLOW = {
  category: 'CarChecker',
};
